export default "__VITE_ASSET__3ea00c78__"